import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.DELETE_SUPPLIER_REQUEST,
    SUCCESS: types.DELETE_SUPPLIER_SUCCESS,
    FAILURE: types.DELETE_SUPPLIER_FAILURE,
    CANCEL: types.DELETE_SUPPLIER_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
